import React from 'react';
import Hero from '../components/home/Hero';
import AuthorityBanner from '../components/home/AuthorityBanner';
import Services from '../components/home/Services';
import About from '../components/home/About';
import BeforeAfterCarousel from '../components/home/BeforeAfterCarousel';
import Quote from '../components/home/Quote';
import Team from '../components/home/Team';
import Testimonials from '../components/home/Testimonials';

const Home: React.FC = () => {
  return (
    <div>
      <Hero />
      <AuthorityBanner />
      <Services />
      <About />
      <BeforeAfterCarousel />
      <Quote />
      <Team />
      <Testimonials />
    </div>
  );
};

export default Home;